<template>
  <component :is="tag" class="aoformlabel" :class="{'aoformlabel_checkboxmode': checkboxmode}" :tabindex="-1">
    <span class="aoformlabel__error" v-if="error">{{error}}</span>
    <slot />
    <span v-if="text" class="aoformlabel__text">{{text}}</span>
    <span v-if="checkboxmode" class="aoformlabel__descr" v-html="descr"></span>
    <div class="aoformlabel__tick"></div>
  </component >
</template>
<script>
export default {
  props: {
    tag: {type: String, default: 'label'},
    text: {type: String},
    error: {type: String},
    checkboxmode: {type: Boolean, default: false},
    descr: {type: String}
  }
}
</script>

<style lang="sass">
.aoformlabel
  display: flex
  flex-direction: column
  justify-content: space-between
  color: colors.$newgray
  font-size: 16px
  line-height: 1
  width: 100%
  height: 56px
  padding-top: 14px
  margin-bottom: 40px
  position: relative
  z-index: 1
  &__datepick-summon-button
    position: absolute
    z-index: 1
    right: 16px
    bottom: 14px
    cursor: pointer
    svg
      display: block
  &__text
    pointer-events: none
    padding-left: 16px
    padding-right: 16px
    order: -1
    display: block
    transition: .3s ease-out
    display: block
    font-size: 16px
    line-height: 26px
    color: colors.$newgray
    letter-spacing: globalvars.$onespacing
    transform: translateY(3px)
  .aoformlabel__error:not(:empty)~.aoformlabel__tick
    display: none !important
  &.filled
    .aoformfield
      border-bottom: 1px solid colors.$newgray
      box-shadow: 0px 1px 0px 0px colors.$newgray
    .aoformlabel__text
      font-size: 12px
      transform: translateY(-11px)
    .aoformlabel__tick::after
      content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTIuNUwxMCAxNS41TDE3IDguNSIgc3Ryb2tlPSIjMDBCOTJEIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=)
      position: absolute
      display: block
      display: none 
      z-index: 100
      width: 24px
      height: 24px
      bottom: 10px
      right: -30px      
      @include from(1000px)
        right: 0
  .aoformfield:focus ~ .aoformlabel__text
    font-size: 12px
    transform: translateY(-11px)
  .aoformfield
    padding-left: 16px
    padding-right: 16px
    margin-top: -11px
    position: relative
    z-index: -1
    transform: translateY(-3px)
    padding-bottom: 3px
    &_datefield
      padding-right: 56px

  outline: none
  &:focus-visible
    outline: auto
  &_checkboxmode
    border: none !important
    display: flex
    align-items: flex-start
  @include for-mob
    margin-bottom: 24px

  &__descr
    margin-left: 16px
    font-weight: 300
    font-size: 14px
    line-height: 24px

  &:focus-within, &.filled
    border-color: colors.$newgray
  &:focus:not(:focus-visible)
    outline: none
  &:focus-within
    position: relative
    z-index: 3
    .aoformfield_witharrow svg
      transform: rotateX(180deg)
  &:focus-within .aoformdroplist
    pointer-events: auto
    opacity: 1
  &:not(:focus-within) .aoformdroplist
    transition: pointer-events .05s, opacity .05s
  &__error
    position: absolute
    white-space: nowrap
    top: calc(100% + 10px)
    left: 0
    font-size: 14px
    line-height: 1.16
    letter-spacing: globalvars.$onespacing
    color: colors.$red

</style>